export const EstateAccountCypressAttribute = {
  buttons: {},
  inputs: {
    ESTATE_ACCOUNT_SELECT: 'EstateAccountCypressAttribute:inputs:ESTATE_ACCOUNT_SELECT',
    ESTATE_ACCOUNT_ESTATE_MEMBER_SELECT:
      'EstateAccountCypressAttribute:inputs:ESTATE_ACCOUNT_ESTATE_MEMBER_SELECT'
  },
  views: {},
  estateSelectionModal: {
    buttons: {
      CANCEL: 'EstateAccountCypressAttribute:estateSelectionModal:CANCEL',
      GO: 'EstateAccountCypressAttribute:estateSelectionModal:GO'
    },
    inputs: {},
    views: {}
  }
};
